export default __webpack_public_path__ + "static/media/img-02.bb223f3c.jpg";